// extracted by mini-css-extract-plugin
export default {"tooltip":"Ezf6e3BNSodmpsJkYf7XvQ=="};